import React from 'react';

interface Step {
  title: string;
  description: string;
}

interface ServiceStepsProps {
  title: string;
  steps: Step[];
  color: string;
  ctaText?: string;
  onCtaClick?: () => void;
}

const ServiceSteps: React.FC<ServiceStepsProps> = ({ 
  title, 
  steps, 
  color,
  ctaText,
  onCtaClick 
}) => {
  return (
    <section>
      <h2 className="text-2xl font-bold mb-8">{title}</h2>
      <div className="bg-white rounded-2xl shadow-lg p-8">
        <ol className="space-y-6">
          {steps.map((step, index) => (
            <li key={index} className="flex items-start">
              <span 
                className="w-8 h-8 rounded-full flex items-center justify-center mr-4 flex-shrink-0"
                style={{ backgroundColor: `${color}15`, color }}
              >
                {index + 1}
              </span>
              <div>
                <h3 className="font-semibold mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </li>
          ))}
        </ol>
        {ctaText && (
          <div className="mt-8 text-center">
            <button
              onClick={onCtaClick}
              className="px-8 py-3 rounded-lg text-white transition-colors hover:opacity-90"
              style={{ backgroundColor: color }}
            >
              {ctaText}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ServiceSteps;